import script from "./timeShift.vue?vue&type=script&lang=ts&setup=true"
export * from "./timeShift.vue?vue&type=script&lang=ts&setup=true"

import "./timeShift.vue?vue&type=style&index=0&id=7f22e28a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f22e28a"]])

export default __exports__